<template>
    <div class="goal-item" @click="clickItem" :class="{'sub-goal-item':isSubItem,'is-risk':isRisk,'active':isActive}">

        <template v-if="isSubItem">
            <p class="label-text fl">{{title}}</p>
            <div class="sub-progress">
                <div class="sub-text">
                    <el-tooltip placement="top" :disabled="!goal.actual_rate||goal.actual_rate=='--'" :content="'实际消耗占比'+goal.actual_rate">
                        <span>{{goal.actual_cost}}</span>
                    </el-tooltip>

                    <span class="absolute" style="right: -3px;">{{goal.target_cost}}</span>
                </div>
                <div class="progress-bar-outer">
                    <div class="el-progress-bar__inner" :style="{width:goal.actual_rate}" v-if="isHasTargetCost"></div>
                    <div class="date-marker" :style="{left:goal.today_predict_rate}" v-if="isHasTargetCost">
                        <el-tooltip placement="top" :disabled="!isRisk">
                            <div slot="content">预估今日应达到消耗目标：{{goal.today_predict_cost}}<br/>当前偏差值：{{goal.diff_cost}}</div>
                            <div class="full-h full-w"></div>
                        </el-tooltip>
                    </div>
                </div>
                <div class="risk-alert" v-if="isRisk">
                    <el-tooltip class="item" content=" KPI完成存在风险，请注意！" placement="top">
                        <img src="../../../assets/img/cost-alert.png" alt="">
                    </el-tooltip>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="top-text relative">
                <span class="title-text font14px text-bold">{{title}}</span>
                <!--<i class="risk-icon el-icon-info ml10"></i>-->
                <div class="risk-alert ml20" v-if="isRisk">
                    <el-tooltip class="item" content=" KPI完成存在风险，请注意！" placement="top">
                        <img src="../../../assets/img/cost-alert.png" alt="">
                    </el-tooltip>
                </div>
                <div class="cost-type" v-if="costType.length>0&&isHasTargetCost">
                    <el-tooltip placement="top">
                        <div slot="content">
                            <p v-if="costType[0]=='1'">考核方式为：总消耗<br/>消耗统计方式为：总消耗（现金+虚拟金）</p>
                            <p v-else-if="costType[0]=='2'">考核方式为：现金<br/>消耗统计方式为：现金消耗</p>
                            <p v-else-if="costType[0]=='3'">考核方式为：虚拟金<br/>消耗统计方式为：虚拟金消耗</p>
                        </div>
                        <span >
                            <img class="cost-icon-img" v-if="costType[0]=='1'" src="../../../assets/img/cost-total-1.png" alt="">
                            <img class="cost-icon-img" v-else-if="costType[0]=='2'" src="../../../assets/img/cost-cash-1.png" alt="">
                            <img class="cost-icon-img" v-else-if="costType[0]=='3'" src="../../../assets/img/cost-virtual-1.png" alt="">
                        </span>
                    </el-tooltip>


                </div>
            </div>
            <div class="progress-bar-outer">
                <div class="el-progress-bar__inner" :style="{width:goal.actual_rate}" v-if="isHasTargetCost"></div>
                <div class="date-marker" :style="{left:goal.today_predict_rate}" v-if="isHasTargetCost">
                    <el-tooltip placement="top" :disabled="!isRisk">
                        <div slot="content">预估今日应达到消耗目标：{{goal.today_predict_cost}}<br/>当前偏差值：{{goal.diff_cost}}</div>
                        <div class="full-h full-w"></div>
                    </el-tooltip>
                </div>
            </div>
            <div class="top-text clear-both">
                <p class="fl">{{goal.actual_cost}}（{{goal.actual_rate}}）</p>
                <p class="fr">{{goal.target_cost}}</p>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "GoalItem",
        props:{
            isSubItem:{
                type:Boolean,
                require:false,
                default:false,
            },
            isRisk:{
                type:Boolean,
                require:false,
                default:false,
            },
            isActive:{
                type:Boolean,
                require:false,
                default:false,
            },
            platId:{
                type:[String,Number],
                require:true,
            },
            goal:{
                type:Object,
                require:true,
            },
            costType:{
                type:[String,Number,Array],
                require:false,
            },
        },
        data(){
            return {
                platMap:{
                   1:'OPPO',
                   3:'vivo',
                   4:'华为',
                   7:'小米',
                },
                sceneTypeMap:{
                    1:'',
                    2:'商店',
                    3:'非商店',
                    4:'信息流',
                    5:'联盟',
                },
            }
        },
        computed:{
            title(){
                if(this.isSubItem){
                    return this.sceneTypeMap[this.goal.scene_type];
                }
                return this.platMap[this.platId];
            },
            isHasTargetCost(){
                let target = this.goal.target_cost;
                return target&&target!='--';
            }
        },
        methods:{
            clickItem(){
                this.$emit('click-item',this.goal);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .goal-item{
        position: relative;
        border-radius: 5px;
        margin-right: 8px;
        padding: 3px;
        color: #333;
        cursor: pointer;
        &.active{
            background-color: #81d3f826;
        }
        .progress-bar-outer{
            width: 100%;
            height: 6px;
            background-color: #d7d7d7;
            border-radius: 3px;
            position: relative;
            .el-progress-bar__inner{
                height: 100%;
                /*width: 50%;*/
                max-width: 100%;
                background-color: #9bd864;
            }
            .date-marker{
                width: 2px;
                height: 12px;
                position: absolute;
                top:-3px;
                background-color: #9bd864;
                z-index: 3;
                left: 60%;
            }
        }

        .top-text{
            line-height: 16px;
            margin: 2px 0;
        }

        .cost-type{
            position: absolute;
            right: 0;
            top: -12px;
            width: 20px;
            height: 24px;
            .cost-icon-img{
                width: 16px;
                max-height: 25px;
            }
        }
    }
    .goal-item.is-risk{
        .el-progress-bar__inner,.date-marker{
            background-color: #e67784!important;
        }
        .risk-icon{
            color: #e67784;
        }
    }
    .sub-goal-item.is-risk{
        .risk-alert{
            position: absolute;
            right: -20px;
            top: 10px;
        }
    }

    .main-goal-item{
        min-height: 60px;
    }
    .sub-goal-item{
        height: 36px;
        position: relative;
        margin-bottom: 12px;
        .label-text{
            line-height: 32px;
            width: 40px;
        }

        .sub-progress{
            position: absolute;
            left: 42px;
            right: 20px;
            top: 0;
            bottom: 0;

            .progress-bar-outer{
                top: 26px;
                height: 3px;
            }

            .date-marker{
                height: 7px;
                position: absolute;
                top:-2px;
                left: 60%;
            }
        }
        .sub-text{
            position: absolute;
            width: 100%;
            color: #7f7f7fe7;
            top:6px;
        }
    }


    .risk-alert{
        cursor: pointer;
        display: inline-block;
        width: 16px;
        height: 16px;
        img{
            width: 100%;
            height: 100%;
        }
    }
</style>
